document.addEventListener("DOMContentLoaded", () => {
  const selectedCity = localStorage.getItem('selectedCity') || 'RIYADH';
  if(selectedCity.trim() == "DOHA") {
    const adonCakeToggles = document.querySelectorAll('.ingredients_toggle')
    if(adonCakeToggles) {
      adonCakeToggles.forEach(input => {
        input.disabled = true
        const label = input.closest('label')
        if(label) {
          label.addEventListener('click', () => {
            window.dispatchEvent(new Event('city-lock:trigger', {bubbles: true, composed: true}));
          })
        }
      })
    }
  }
})

class AvailabilityModal extends HTMLElement {
  constructor() {
    super();

    this.modal = this.querySelector('.modal');
    this.closeButton = this.querySelector('.modal__close');
  }
  connectedCallback() {
    
    const closeButton = this.querySelector('.modal__close');
    if (closeButton) {
      closeButton.addEventListener('click', () => this.close());
    }

    window.addEventListener('city-lock:trigger', () => {
      this.open()
    })
  }

  open() {
    this.modal.classList.add('modal--active');
  }

  close() {
    this.modal.classList.remove('modal--active');
  }
}

customElements.define('availability-modal', AvailabilityModal);